import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentContext = createContext(null);
export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const reload = async () => {
    const { data } = await axios.get(`${API}/content`);
    setContent(data.content);
  };

  useEffect(() => {
    reload().catch((e) => console.error("content load failed", e));
  }, []);

  return (
    <ContentContext.Provider value={{ content, reload, loading: !content }}>
      {children}
    </ContentContext.Provider>
  );
}
